import { useEffect, useMemo, useRef, useState, useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axiosInstance from '../../axios';
import AuthContext from '../../AuthContext';
import { Menu } from '@mantine/core';
import { useNavigate,useLocation } from 'react-router-dom';
import { Paper } from '@mantine/core';
import Centre from '../Dropdowns/Centre'
const Example = ({ updateProductModalSetting, handlePageUpdate }) => {
  const { centre, userType, trainer } = useContext(AuthContext);
  const [bcentre,setCentre]=useState(localStorage.getItem('bcentre')||'');
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const [day, month, year] = new Date(dateString).toLocaleDateString('en-GB', options).split('/');
    return `${day}-${month}-${year}`;
  };
useEffect(() =>{
if(bcentre){
  localStorage.setItem('bcentre',bcentre);
}
},[bcentre])
  const navigate = useNavigate();
  const columns = useMemo(
    () => [
      { accessorKey: 'batch_name', header: 'Batch Name' },
      { accessorKey: 'sector_name', header: 'Sector Name' },
      { accessorKey: 'tbn_no', header: 'Batch Id/TBN No.' },
      { accessorKey: 'batch_type', header: 'Batch Type' },
      { accessorKey: 'batch_phase', header: 'Batch Phase' },
      {accessorKey: 'scheme_name', header: 'Scheme Name' },
      { accessorKey: 'job_role_name', header: 'Job Role Name' },
      { accessorKey: 'start_date', header: 'Start Date', Cell: ({ cell }) => formatDate(cell.getValue()) },
      { accessorKey: 'end_date', header: 'End Date', Cell: ({ cell }) => formatDate(cell.getValue()) },
      { accessorKey: 'capacity', header: 'TC Capacity' },
      { accessorKey: 'course_hour', header: 'Duration' },
      { accessorKey: 'status', header: 'Status' },
      { accessorKey: 'to_enrolled_no', header: 'Batch Size' },
      { accessorKey: 'course_code', header: 'Course Code' },
      { accessorKey: 'trainer_names', header: 'Trainer Name' },
      { accessorKey: 'assest_by', header: 'Assessed By' },
      { accessorKey: 'assesment_id', header: 'Assessment ID' },
      { accessorKey: 'assesment_date', header: 'Assessment Date',Cell: ({ cell }) => formatDate(cell.getValue()) },
      { accessorKey: 'study_material_distribution', header: 'Study Material Distribution' },
      { accessorKey: 'uniform_distribution', header: 'Uniform Distribution' }
    ],
    []
  );
  const rowVirtualizerInstanceRef = useRef(null);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (userType === 'Trainer') {
          const response = await axiosInstance.post('/batch/getbyTrainerId', { trainer_id: trainer });
          setData(response.data.batch);
        }
        else if (bcentre) {
          const response = await axiosInstance.post('/batch/getAll', { centre_id: bcentre });
          setData(response.data)
          //console.log(response.data)
        }
        else {
          const response = await axiosInstance.post('/batch/getAll', { centre_id: centre });
          setData(response.data);
          //console.log(response.data)
        }
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [handlePageUpdate, centre, trainer, userType,bcentre]);

  useEffect(() => {
    try {
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      console.log(e);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
        {(userType !== 'Trainer' && userType!=='Accounts') && (
          <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Edit</Menu.Item>
        )}
        <Menu.Item onClick={() => navigate(`/batches/details`, {
          state: { id: row.original.batch_id }
        }, { replace: true })}>Details</Menu.Item>
        <Menu.Item onClick={() => navigate(`/batches/students`, {
          state: { id: row.original.batch_id }
        })}>
          View Students
        </Menu.Item>
      </>
    ),
  });

  return (
    <Paper shadow="sm" p="lg" withBorder>
      <div style={{ marginBottom: '20px', maxWidth: '300px', margin: '0 auto' }} >
      {(userType==='Superadmin'|| userType==='Accounts'||userType==='Manager')&&(
        <Centre
         handleInputChange={e=>setCentre(e.target.value)} value={bcentre} yes={true}/>
      )}
      </div>
      
      <MantineReactTable
        table={table}
        striped // Enables the striped rows
        highlightOnHover
        horizontalSpacing="md"
        verticalSpacing="sm"
        fontSize="sm"
        withColumnBorders
        borderRadius="md"
        withGlobalFilter
        height={400}
        rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
        enablePagination={true} // Enables pagination
      />
    </Paper>
  );
};

export default Example;
